// helpers/index.js
// Yuan Wang
// Copyright American Marine Research Company LLC 2019

export const PLACEHOLDER_IMAGE = "http://joshhaldeman.com/wp-content/uploads/2014/05/thumbnails1.jpg"

export const APP_STORE_LINK = "#"

export const validateEmail = (email) => {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}